export default __webpack_public_path__ + "static/media/kitchen-1.be340e25.jpg";